var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"alert_phone_ver d-flex justify-content-start align-items-start flex-column w-100",staticStyle:{"margin-top":"24px"},attrs:{"dense":"","color":"#FFF3CD"}},[_c('span',{staticClass:"text-center mt-2",staticStyle:{"color":"#856404"}},[_vm._v(" "+_vm._s(_vm.$t('Nodata')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }